var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-integrations-form"},[_c('VForm',{attrs:{"name":_vm.name,"fields":_vm.formData.fields,"disabled":!_vm.isValid,"initialValues":{
      display_drip: _vm.getUser.display_drip,
      display_hubspot: _vm.getUser.display_hubspot
    }},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }